import { SvgIcon } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import { useContext, useState } from 'react';

import { authContext } from '../../../contexts';
import { Avatar } from '../../../shared/components';

const useStyles = makeStyles((theme) => ({
  menuItemWrapper: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '120px',
    color: theme.palette.text.secondary,
  },
}));
export const AvatarMenu: React.FC = () => {
  const classes = useStyles();
  const { onLogout, me } = useContext(authContext);
  const [avatarMenuEl, setAvatarMenuEl] = useState<Element | null>(null);

  const handleAvatarClick = (event: React.MouseEvent<HTMLElement>) => {
    setAvatarMenuEl(event.currentTarget);
  };

  const handleClose = () => {
    setAvatarMenuEl(null);
  };

  const getInitials = () => {
    if (me) {
      let { name } = me;
      name = name.toUpperCase();
      const firstInitial = name[0];
      const indexOfFirstSpace = name.indexOf(' ');
      const secondInitial =
        indexOfFirstSpace !== -1 ? name[indexOfFirstSpace + 1] : name[1];

      return firstInitial + secondInitial;
    }
  };

  return (
    <>
      <Avatar initial={getInitials()} onClick={handleAvatarClick} />
      {avatarMenuEl && (
        <Menu
          PaperProps={{
            style: {
              marginTop: '45px',
            },
          }}
          getContentAnchorEl={null}
          id="avatar-menu"
          anchorEl={avatarMenuEl}
          keepMounted
          open={Boolean(avatarMenuEl)}
          onClose={handleClose}>
          <MenuItem onClick={onLogout}>
            <div className={classes.menuItemWrapper}>
              <SvgIcon>
                <path d="M16 16V1H12V0H2V16H0V18H12V3H14V18H18V16H16ZM10 16H4V2H10V16ZM9 8H7V10H9V8Z" />
              </SvgIcon>
              Log Out
            </div>
          </MenuItem>
        </Menu>
      )}
    </>
  );
};
